import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
  Button,
  Form,
  Grid,
  Header,
  Modal,
} from 'semantic-ui-react';
import { Trans, withTranslation } from 'react-i18next';
import { flashErrorMessage } from '../../actions/flash';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';


class UpdateCaseStatus extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    onConfirm: PropTypes.func,
    bankerName: PropTypes.string,
    statusName: PropTypes.string,
    loanAmount: PropTypes.string,
    spaValue: PropTypes.number,
  }
  constructor(props) {
    super(props);
    const loanAmount = props.loanAmount;
    this.state = {
      loanAmount,
      statusNote: '',
    };
  }
  componentWillReceiveProps(nextProps) {
    const loanAmount = nextProps.loanAmount;
    const loanMargin = this.getLoanMargin(this.state.loanAmount, nextProps.spaValue);
    if (this.props.open !== nextProps.open) {
      this.setState({
        statusNote: '',
      });
    }

    this.setState({ loanAmount, loanMargin });
  }
  getLoanMargin = (loanAmount, spaValue) => {
    const sellingPrice = spaValue || 0;
    const caseLoanAmount = loanAmount ? parseInt(loanAmount, 10) : 0;
    let loanMargin = 0;
    if (sellingPrice > 0 && caseLoanAmount > 0) {
      loanMargin = Math.ceil((caseLoanAmount / sellingPrice) * 100);
    }
    return loanMargin;
  }
  getPercentageOptions = () => {
    let options = [];
    for (let i = 0; i <= 100; i += 1) {
      options = [...options, {
        key: i,
        value: i,
        text: `${i}%`,
      }];
    }
    return options;
  }
  handleOnClose = (e) => {
    if (this.props.onClose) {
      this.props.onClose(e);
    }
  }
  handleOnComfirm = (e) => {
    e.preventDefault();
    const { store } = this.context;
    const { t } = this.props;
    if (this.props.statusName === 'LO Signed') {
      if (parseInt(this.state.loanAmount, 10) < 1) {
        return store.dispatch(flashErrorMessage({ message: t('Loan Amount is required', { ns: TRANSLATION_FILES.translation }) }));
      }
      if (parseInt(this.state.loanAmount, 10) > parseFloat(this.props.spaValue)) {
        return store.dispatch(flashErrorMessage({ message: t('Loan Amount must be less than Selling Price', { ns: TRANSLATION_FILES.translation }) }));
      }
    }
    if (this.props.onConfirm) {
      this.props.onConfirm(e, this.state.statusNote, this.state.loanAmount);
    }
  }
  handleOnChange = (e, { value }) => {
    this.setState({
      statusNote: value,
    });
  }
  handleOnLoanAmountChange = (e, { value }) => {
    const { spaValue } = this.props;
    const { loanAmount, loanMargin } = this.state;
    const sellingPrice = spaValue || 0;
    let caseLoanAmount = loanAmount;
    let loanPercent = loanMargin;
    let amount = 0;

    if (value !== '') {
      amount = parseInt(value, 10);
    }
    if (sellingPrice > 0) {
      loanPercent = Math.ceil((amount / sellingPrice) * 100);
      caseLoanAmount = amount;
    }

    this.setState({ loanAmount: caseLoanAmount, loanMargin: loanPercent });
  }
  handleOnLoanMarginChange = (e, { value }) => {
    const { spaValue } = this.props;
    const { loanAmount, loanMargin } = this.state;
    const sellingPrice = spaValue || 0;
    let caseLoanAmount = loanAmount;
    let loanPercent = loanMargin;
    let amount = 0;

    if (value !== '') {
      amount = parseInt(value, 10);
    }
    if (sellingPrice > 0) {
      loanPercent = _.toNumber(amount);
      caseLoanAmount = Math.floor((loanPercent / 100) * sellingPrice);
    }

    this.setState({
      loanAmount: caseLoanAmount,
      loanMargin: loanPercent,
    });
  }
  render() {
    const { t } = this.props;
    return (
      <Modal
        size="small"
        open={this.props.open === true}
        onClose={this.handleOnClose}
      >
        <Header icon="info" content={t('Update Loan Status')} />
        <Modal.Content>
          <Modal.Description>
            <Trans ns={TRANSLATION_FILES.screens}>
              <p>
                Change <strong>{{bankerName: this.props.bankerName}}</strong>&apos;s status to <strong>
                  {{status: this.props.statusName}}</strong>?
              </p>
            </Trans>
            {
              this.props.statusName === 'LO Signed' ? (
                <Grid>
                  <Grid.Row style={{ marginBottom: '1em' }}>
                    <Grid.Column mobile={16} tab={8} computer={8}>
                      <Form.Select
                        fluid
                        label={t('Loan Margin')}
                        name="loanMargin"
                        options={this.getPercentageOptions()}
                        placeholder="0%"
                        selectOnBlur={false}
                        value={this.state.loanMargin}
                        onChange={this.handleOnLoanMarginChange}
                      />
                    </Grid.Column>
                    <Grid.Column mobile={16} tab={8} computer={8}>
                      <Form.Input
                        fluid
                        name="loanAmount"
                        label={`${t('Loan Amount')}*`}
                        type="number"
                        min="0"
                        value={this.state.loanAmount}
                        onChange={this.handleOnLoanAmountChange}
                        step="1"
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              ) : null
            }
            <Form.Input
              fluid
              label={t('Status Note')}
              value={this.state.statusNote}
              onChange={this.handleOnChange}
            />
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button basic negative onClick={this.handleOnClose} icon="cancel" content={t('No', { ns: TRANSLATION_FILES.constants })} inverted />
          <Button basic positive onClick={this.handleOnComfirm} icon="checkmark" content={t('Yes', { ns: TRANSLATION_FILES.constants })} inverted />
        </Modal.Actions>
      </Modal>
    );
  }
}

export default withTranslation(namespaces)(UpdateCaseStatus);



// WEBPACK FOOTER //
// ./src/containers/modals/UpdateCaseStatus.jsx